import { Center, HStack, Link, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const Footer = () => {
  return (
    <Center height={["auto", "auto", "45px", "45px", "50px", "60px"]} backgroundColor="#ACE0F4" marginTop={"20px"} py={2}>
      <HStack spacing={4} flexWrap="wrap" justify="center">
        <Text fontSize={["12px", "13px", "14px", "15px", "16px", "17px"]}>
          Copyright © 2024 Going Solo - A Solo Travel App - All Rights Reserved.
        </Text>
        <HStack spacing={4} fontSize={["12px", "13px", "14px", "15px", "16px", "17px"]}>
          <Link as={RouterLink} to="/privacy" color="blue.700">Privacy Policy</Link>
          <Link as={RouterLink} to="/terms" color="blue.700">Terms of Service</Link>
        </HStack>
      </HStack>
    </Center>
  );
};

export default Footer;
